import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {AdminService} from '../services/admin.service';
import {
  CALENDAR_MONTH_OFFSET,
  COUNTER_STEP,
  DATE_FORMAT,
  DATE_TIME_SEPARATOR,
  INITIAL_COUNTER_VALUE,
  MINIMUM_CHANGE_DESCRIPTION_LENGTH,
  MODAL_RESULT_CONTINUE,
  TIME_FORMAT
} from './report-datepicker.constants';
import {ReportDatepickerActionView} from './report-datepicker.types';
import {ReportDatepickerUiGateway} from './report-datepicker-ui.gateway';

@Injectable()
export class ReportDatepickerActionCoordinator {
  constructor(
    private adminService: AdminService,
    private ui: ReportDatepickerUiGateway
  ) {
  }

  selectAction(view: ReportDatepickerActionView, action: string, userId: string): void {
    view.actionType = action;
    view.activeUserId = userId;
  }

  isActionEnabled(view: ReportDatepickerActionView): boolean {
    return view.changeLog.length >= MINIMUM_CHANGE_DESCRIPTION_LENGTH;
  }

  incrementAmount(view: ReportDatepickerActionView): void {
    view.currentValue += COUNTER_STEP;
  }

  decrementAmount(view: ReportDatepickerActionView): void {
    if (view.currentValue > INITIAL_COUNTER_VALUE) {
      view.currentValue -= COUNTER_STEP;
    }
  }

  setTitle(view: ReportDatepickerActionView, title: string): void {
    view.title = title;
  }

  saveKarmaChange(view: ReportDatepickerActionView): void {
    const createdAt = this.actionDate(view);
    const change = {
      userID: view.activeUserId, description: view.changeLog,
      direction: view.actionType, amount: view.currentValue, dataCreate: createdAt
    };
    this.adminService.changeKarma(change).subscribe(
      () => this.ui.close(MODAL_RESULT_CONTINUE),
      () => undefined
    );
  }

  saveEmploymentDate(view: ReportDatepickerActionView): void {
    const fromDate = this.date(view);
    this.adminService.changeEmploy(view.userId, this.formattedDate(fromDate)).subscribe(
      () => this.ui.close(fromDate),
      () => undefined
    );
  }

  planfixUrl(taskId: number): string {
    return this.ui.planfixUrl(taskId);
  }

  openPlanfix(taskId: number): void {
    this.ui.openPlanfix(taskId);
  }

  private actionDate(view: ReportDatepickerActionView): string {
    return this.formattedDate(this.date(view));
  }

  private formattedDate(date: Date): string {
    return moment(date).format(
      DATE_FORMAT + DATE_TIME_SEPARATOR + moment().format(TIME_FORMAT));
  }

  private date(view: ReportDatepickerActionView): Date {
    return new Date(view.from.year, view.from.month - CALENDAR_MONTH_OFFSET, view.from.day);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-action.coordinator.ts